import { useEffect } from "react";
import { setAddButtonsVisible } from "../add-buttons";

type UseAddButtonsVisibilityArgs = {
  tableToolbarVisible: boolean;
  imageToolbarVisible: boolean;
  linkTooltipVisible: boolean;
  imageModalOpen: boolean;
};

export function useAddButtonsVisibility({
  tableToolbarVisible,
  imageToolbarVisible,
  linkTooltipVisible,
  imageModalOpen,
}: UseAddButtonsVisibilityArgs) {
  useEffect(() => {
    const isAnyPanelVisible =
      tableToolbarVisible ||
      imageToolbarVisible ||
      linkTooltipVisible ||
      imageModalOpen;
    setAddButtonsVisible(!isAnyPanelVisible);
  }, [tableToolbarVisible, imageToolbarVisible, linkTooltipVisible, imageModalOpen]);
}

